// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__ly6Km","header":"MergedInvoice_header__1Lfom"};